import React from "react";
import { Box, Container } from "@mui/material";
import NavBar from "../../../Components/Widgets/Navbar";
import MenuDrawer from "../../../Components/Widgets/MenuDrawer";
import SubMenuDrawer from "../../../Components/Widgets/SubMenuDrawer";
import CartDrawer from "../../../Components/Widgets/CartDrawer";
import TopBannersSlider from "../../../Components/Widgets/Sliders/TopBannersSlider";
import Appointment from "../../../Components/Widgets/Appointment";

import Translate from "../../../../modules/Core/Components/Translate";
import Footer from "../../../Components/Widgets/Footer";

const ExportDefault = (props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "#F7F8FA",
      }}
    >
      <NavBar {...props} />
      <MenuDrawer {...props} />
      <SubMenuDrawer {...props} />
      <CartDrawer {...props} />
      <Container
        maxWidth="lg"
        disableGutters
        sx={{
          mt: 2,
          px: 2,
          textAlign: "center",
          "& h4": {
            lineHeight: 2,
            fontSize: { xs: 20, md: 24 },
            mb: 0,
            mt: 1,
          },
          "& h5": {
            fontWeight: 400,
            lineHeight: 2,
            fontSize: { xs: 16, md: 20 },
            mb: 0,
            mt: 1,
          },
          "& a": {
            textTransform: "none",
            textDecoration: "none",
            color: "#333",
            "&:hover,&:focus": { color: "#333", opacity: 0.9 },
          },
          "& i": {
            mr: 1,
          },
        }}
      >
        <Translate
          entity="item"
          eslug="special-event"
          scope="default"
          slug="default"
          auto
        />
      </Container>
      <Appointment
        {...{
          ...props,
          ...{
            store: "store-4",
            dates: ["2025-05-07", "2025-05-08", "2025-05-09", "2025-05-10"],
          },
        }}
      />
      <TopBannersSlider
        {...{
          ...props,
          ...{
            text_color: "#fff",
            top: "50%",
            left: "50%",
            center: "-50%,-50%",
            slides: [
              {
                slug: "slider-prive-bazaar",
                url: "/special-evenrt",
              },
            ],
          },
        }}
      />
      <Footer {...props} />
    </Box>
  );
};

export default ExportDefault;
